import React, { useMemo } from 'react'
import { useEventsPageState } from 'Event/hooks/useEventsPageState'
import { useCurrentOrg } from 'auth/hooks'
import { getEventsPageFallbackUrl } from './eventsBack'
import { useStackBack } from './useStackBack'

interface EventDetailsBackProps {
  label?: string
}

export function EventDetailsBack({ label = 'Events' }: EventDetailsBackProps) {
  const [eventsPage] = useEventsPageState()
  const org = useCurrentOrg()

  const fallbackUrl = useMemo(() => getEventsPageFallbackUrl(eventsPage, org.timeZone), [eventsPage, org.timeZone])

  const { label: backLabel, goBack } = useStackBack({
    url: fallbackUrl,
    label,
  })

  return (
    <div className="detail_event_block_back_arrow" onClick={goBack}>
      <img src="/assets/icons/back-arrow.svg" alt="icon" className="arrow" />
      {backLabel}
    </div>
  )
}
